import VulnsRender from './vulns_render'
export default VulnsRender